import React, { useEffect, useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import './css/TopRootDiv.css'
import vect from './images/SideNav/Calendar1.png'
import vect1 from './images/SideNav/Checklist1.png'
import vect2 from './images/SideNav/Statistics1.png'
import vect3 from './images/SideNav/Vector1.png'
import vect4 from './images/SideNav/msg.png'
import vect5 from './images/SideNav/sett.png'
import vect6 from './images/SideNav/vec.png'
import vect7 from './images/SideNav/vec1.png'
import Order1 from './images/SideNav/Order1.png'
import Inventorymanagement1 from './images/SideNav/Inventorymanagement1.png'
import Diningtable from './images/SideNav/Diningtable withchairs1.png'
import Menu1 from './images/SideNav/Menu1.png'
import Select from 'react-select';
import { useLanguage } from './LanguageContext';
import { DineContext } from './DineContext'
import axios from 'axios'
import io from 'socket.io-client';
import { DBContext } from './DBContext'
import report from '../assets/images/report.png';

function TopRootDiv({ image, root, section, type }) {

	const api_base_url = process.env.REACT_APP_API_BASE_URL

	const { logginedDB, customerCode, handleGetCompanyDetails } = useContext(DBContext);

	const { clearLoadOrder, holdLoad, previousOrders, setHoldLoadOrderFunc, setClearLoadOrderFunc, setPreviewPreviousOrders } = useContext(DineContext);

	const navigate = useNavigate();

	let subRoot1;
	let subRoot2;
	let subRoot3;
	let subRoot4;

	if (root[0]) {
		if (root[0] === 'Dashboard') {
			subRoot1 = 'ViewDashboard'
		}
		if (root[0] === 'Menu Management') {
			subRoot1 = 'Menu'
		}
		if (root[0] === 'User Management') {
			subRoot1 = 'BillerApp'
		}
		if (root[0] === 'Inventory') {
			subRoot1 = 'Inventory'
		}
		if (root[0] === 'KOT') {
			subRoot1 = 'KitchenDisplaySystem'
		}
		if (root[0] === 'Tables') {
			subRoot1 = 'TableView'
		}
		if (root[0] === 'Report') {
			subRoot1 = 'Report'
		}
	}
	if (root[1]) {
		if (root[1] === 'Base Menu') {
			subRoot2 = 'BaseMenuReg'
		}
		if (root[1] === 'Recipe Management') {
			subRoot2 = 'RecipeManagement'
		}
	}
	if (root[2]) {
		if (root[2] === 'Recipe Management') {
			subRoot3 = 'RecipeManagement'
		}
	}
	// if (root[3]) {
	// 	if (root[3] === 'Report') {
	// 		subRoot4 = 'Report'
	// 	}
		
	// }

	const toSubRoot1 = () => {
		navigate(`/${subRoot1}`);
	}
	const toSubRoot2 = () => {
		navigate(`/${subRoot2}`);
	}
	const toSubRoot3 = () => {
		navigate(`/${subRoot3}`);
	}
	const toSubRoot4 = () => {
		navigate(`/${subRoot4}`);
	}

	const displayImage = (image) => {
		if (image === 'Dashboard') {
			return vect2
		}
		if (image === 'Menu Management') {
			return Menu1
		}
		if (image === 'Inventory') {
			return Inventorymanagement1
		}
		if (image === 'Order & Billing') {
			return Order1
		}
		if (image === 'Tables') {
			return Diningtable
		}
		if (image === 'Settings') {
			return vect5
		}
		if (image === 'Report') {
			return report
		}
	}

	const [loadOrder, setLoadOrder] = useState(false)

	useEffect(() => {
		if (section === 'KOT') {
			setLoadOrder(true)
		}
	}, [section])

	const customStyles = {
		option: (provided, state) => ({
			...provided,
			width: '100%',
			fontSize: '0.881rem',
			fontFamily: 'Nunito',
			zIndex: 9999,
			backgroundColor: state.isSelected ? '#c8cbcf' : '#FFF',
			backgroundColor: state.isFocused ? '#c8cbcf' : '#FFF',
			color: state.isFocused ? '#000' : '#000',
			':active': {
				...provided[':active'],
				backgroundColor: '#c8cbcf'
			}
		}),
		input: (provided) => ({
			...provided,
			// height: '2.5rem',
			width: '100% !important',
			fontSize: '0.881rem',
			fontFamily: 'Nunito',
			cursor: 'none',
			zIndex: 9999,
			'&:hover': {
				cursor: 'text'
			},
			'&:focus': {
				cursor: 'default',
			},
			// display: 'none', 
			color: "#2B3034"
		}),
		valueContainer: (provided) => ({
			...provided,
			overflow: 'hidden',
			fontSize: '0.881rem',
			zIndex: 9999,
		}),
		indicatorSeparator: (provided, state) => ({
			...provided,
			// display: 'none', 
		}),
		dropdownIndicator: (provided, state) => ({
			...provided,
			// height: '1.5rem !important', 
			marginTop: 0, // Adjust vertical alignment if needed
		}),
		control: (provided, state) => ({
			...provided,
			width: '8.5rem !important',
			// height: '1.5rem  !important ',
			zIndex: 9999,
			fontSize: '0.881rem',
			fontFamily: 'Nunito',
			// maxHeight: '1rem !important',
			border: '1px solid #D5D5D5',
			borderRadius: '0.313rem',
			textAlign: 'left',
			boxShadow: 'none',
			'&:hover': {
				border: '1px solid #C6C6C6',
			},
			'&:focus': {
				outline: 'none', // Remove outline on focus
				cursor: 'default', // Remove cursor on focus
			},
		}),
		placeholder: (provided, state) => ({
			...provided,
			fontSize: '0.881rem',
		}),
		menu: (provided, state) => ({
			...provided,
			fontSize: '.9rem',
			textAlign: 'left',
			zIndex: 9999,
		}),
	};

	const [selectedOption, setSelectedOption] = useState(null)
	const { selectedLanguage, setSelectedLanguage } = useLanguage();

	// Function to handle select change
	const handleCalender = (selectedOption) => {
		setSelectedOption(selectedOption);
		// if (selectedOption)
		// //(selectedOption.label);
		setSelectedLanguage(selectedOption.value);
	};

	const [holdInformations, setHoldInformations] = useState([])

	const handleGetHoldOrders = async () => {
		try {
			const response = await axios.get(`${api_base_url}/getHoldOrders/${logginedDB}`)
			if (response.status == 200) {
				setHoldInformations(response.data)

			}
		} catch (error) {
			//(error);
		}
	}

	useEffect(() => {
		handleGetHoldOrders()
	}, [])

	// useEffect(() => {
	//   // Connect to the WebSocket server
	//   const socket = io(api_base_url, {
	//       transports: ['websocket'], // Force WebSocket to avoid fallback issues
	//   });

	//   // Avoid adding multiple listeners
	//   socket.on('updateLoadOrders', handleGetHoldOrders);
	//   socket.on('updateCompany', handleGetCompanyDetails);

	//   return () => {
	//       socket.off('updateLoadOrders', handleGetHoldOrders);
	//       socket.off('updateCompany', handleGetCompanyDetails);
	//       socket.disconnect();
	//   };
	// }, []);

	const calender_options = [
		{ value: 'MAL', label: 'Malayalam' },
		{ value: 'ENG', label: 'English' },
		{ value: 'ARA', label: 'Arabic' },
		{ value: 'MALAY', label: 'Malay' },
		{ value: 'HIN', label: 'Hindi' },
		{ value: 'TAM', label: 'Tamil' }
	];

	return (
		<div className='h-max w-full flex bg-[#fff] py-1 pl-1'>
			<div className='w-full flex flex-col'>
				{type == 'Dashboard' ? (
					<div className='root_dashboard'>
						<div className='TopRootDiv_root TopRootDiv_root_dashboard'>
							<div className='TopRootDiv_root_img'>
								<img src={displayImage(image)} alt="?" />
							</div>
							<span onClick={toSubRoot1}>{root[0]} {root[0] ? '/' : ''}</span>
							<span onClick={toSubRoot2}>{root[1]} {root[1] ? '/' : ''}</span>
							<span onClick={toSubRoot3}>{root[2]} {root[2] ? '/' : ''}</span>
							<span onClick={toSubRoot4}>{root[4]} {root[4] ? '/' : ''}</span>
						</div>
						<div className='TopRootDiv_root_dashboard_right'>
							<div className='TopRootDiv_root_dashboard_div'>
								{/* <Select
                        styles={customStyles}
                        value={selectedOption}
                        onChange={handleCalender}
                        options={calender_options}
                    /> */}
							</div>
							{/* <div className='TopRootDiv_root_dashboard_div'>Admin</div> */}
						</div>
					</div>
				) : (
					<div className='w-full gap-2 flex justify-start items-center font-[500] font-nunito text-[.85em]'>
						<div className='flex justify-center items-center'>
							<img className='w-[1rem]' src={displayImage(image)} alt="?" />
						</div>
						<span className='hover:text-[#0008B4] hover:font-[600] cursor-pointer' onClick={toSubRoot1}>{root[0]} {root[0] ? '/' : ''}</span>
						<span className='hover:text-[#0008B4] hover:font-[600] cursor-pointer' onClick={toSubRoot2}>{root[1]} {root[1] ? '/' : ''}</span>
						<span className='hover:text-[#0008B4] hover:font-[600] cursor-pointer' onClick={toSubRoot3}>{root[2]} {root[2] ? '/' : ''}</span>
						<span className='hover:text-[#0008B4] hover:font-[600] cursor-pointer' onClick={toSubRoot4}>{root[4]} {root[4] ? '/' : ''}</span>
					</div>
				)}
				<div className='w-full flex justify-start items-center font-[600] font-nunito text-[.813em]'>
					<span>{section}</span>
				</div>
			</div>
			{
				loadOrder && (
					<div className='w-max flex justify-end items-end font-[600] font-nunito text-[1rem] gap-2'>
						{/* {previousOrders.length > 0 && (
                  <button className='rounded-[.313rem] px-4 py-1 bg-[#0008B4] text-[#fff]'
                  onClick={() => {
                    setPreviewPreviousOrders(a => !a)
                  }}
                  >Orders</button>
                )} */}
						{clearLoadOrder && (
							<button className='rounded-[.313rem] px-4 py-1 bg-[#0008B4] text-[#fff]'
								onClick={() => {
									handleGetHoldOrders()
									setClearLoadOrderFunc(false)
								}}
							>Clear</button>
						)}
						{(holdInformations.length > 0 && !clearLoadOrder) && (
							<button className={`rounded-[.313rem] px-4 py-1 ${holdLoad ? 'bg-[#b3b3b3] text-[#333333]' : 'bg-[#0008B4] text-[#fff]'}`}
								onClick={() => setHoldLoadOrderFunc('load')}
								disabled={holdLoad}>Load</button>
						)}
					</div>
				)
			}
		</div>
	)
}

export default TopRootDiv
